<template>

</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {

}
</script>